<template>
      <b-container  class="headerPushDown">        
            <b-container v-if="validOrdersFound() && !onSuccess" class=" ml-auto mr-auto">                
                <b-row>

                    <b-col  sm="12" md="6" class="">
                         <h4 class="text-uppercase">Zusammenfassung</h4>
                         <b-row>
                             <b-col cols="3" class="text-uppercase">Datum:</b-col>
                             <b-col cols="8">{{ getDateOfBooking }}</b-col>
                         </b-row>    
                         <b-row>
                             <b-col cols="3" class="text-uppercase">Uhrzeit:</b-col>
                             <b-col cols="8">{{ getTimeOfBooking }}</b-col>
                         </b-row>
                        <b-row>
                             <b-col cols="3" class="text-uppercase">Anzahl:</b-col>
                             <b-col cols="8"> {{this.$store.getters.getCachedBooking.amount }}</b-col>
                    </b-row>                         
                    <p class="mt-4">Ihre Reservierung wird für 30 Minuten freigehalten.</p>

                    </b-col>

                    <b-col sm="12" md="6">
                        <form @submit.stop.prevent="handleSubmit">
                            <h4 class="text-uppercase">Informationen</h4>
                            <b-form-group class="pl-3 pr-3">
                                <b-row>
                                    <b-col cols="6">
                                        <label class="mb-0 text-uppercase">Vorname*</label>
                                        <b-input type="text" size="sm" placeholder="Vorname" class="mt-1 mb-2 InputBorder "
                                            :state="firstnameState"  :class="{'is-invalid' : !booking.firstnameIsValid}" 
                                            aria-describedby="input-live-feedback" id="firstname" v-model="booking.firstname"/>
                                        <b-form-invalid-feedback id="input-live-feedback">
                                            min. {{validation.lastname.MinLetters }} Buchstaben
                                        </b-form-invalid-feedback>
                                    </b-col>
                                    <b-col cols="6">
                                        <label class="mb-0 text-uppercase">Nachname*</label>
                                        <b-input type="text" size="sm" placeholder="Nachname" class="mt-1 mb-2 InputBorder" 
                                            :state="lastnameState"
                                            :class="{'is-invalid' : !booking.lastnameIsValid}"
                                            aria-describedby="input-live-feedback" id="lastname" v-model="booking.lastname"/>
                                        <b-form-invalid-feedback id="input-live-feedback">
                                            min. {{validation.lastname.MinLetters }} Buchstaben
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>

                                <label class="mb-0 text-uppercase">E-Mail Adresse*</label>
                                <b-input type="email" size="sm" placeholder="E-Mail" class="mt-1 mb-2  InputBorder" id="email" v-model="booking.email" aria-describedby="input-live-feedback" 
                                    :state="emailState"
                                    :class="{'is-invalid' : !booking.emailIsValid}"
                                    />
                                
                                <label class="mb-0 text-uppercase">E-Mail Adresse wiederholen*</label>
                                <b-input type="email" size="sm" placeholder="E-Mail" class="mt-1 mb-2  InputBorder" id="email_" v-model="booking.email2" aria-describedby="input-live-feedback" 
                                    :state="emailState"
                                    :class="{'is-invalid' : !booking.emailIsValid}"
                                    />
                                <b-form-invalid-feedback id="input-live-feedback" class="mb-2">
                                    Bitte eine E-Mail Adressen überprüfen
                                </b-form-invalid-feedback>
                            
                                <b-form-checkbox class="mt-2"
                                    v-if="showNewsLetter"
                                    id="newsletter"
                                    v-model="booking.newsletter"
                                    value="true"
                                    unchecked-value="false">
                                    Newsletter anfordern
                                </b-form-checkbox>

                                <label v-if="showBirthDateInput" class="mb-0 mt-2 text-uppercase">Geburtsdatum</label>                                
                                <div v-if="showBirthDateInput" class="mt-1 mb-2 " :class="$options.name">
                                    <form-date v-model.lazy="booking.birthdate" ref="BirthDateInput" />
                                </div>

                                <label class="mb-0 text-uppercase mt-2">Telefon</label>
                                <b-input type="tel" size="sm" placeholder="Tel." class="mt-1 mb-2  InputBorder" v-model="booking.phone"/>

                                <label class="mb-0 text-uppercase">Anmerkungen</label>
                                <b-textarea size="sm" placeholder="Besondere Wünsche?" class="mt-1 mb-2  InputBorder" v-model="booking.note" ></b-textarea>
<p>*Pflichtfelder</p> 
                                <vue-recaptcha v-if="siteKey" :sitekey="siteKey" class="w-100" style="float: right;" ref="recaptcha" @expired="onCaptchaExpired" @verify="onCaptchaVerified"></vue-recaptcha>

                                <div v-if="validationError !=''" class="mr-auto ml-auto d-inline-block text-danger mb-2">
                                    <div v-for="(vError, index) in validationError" :key="index">
                                    {{vError}}
                                </div>
                                </div>
                                
                                <b-button v-if="!reCaptchaOK" class="mt-3 text-uppercase" variant="light" disabled style="float: right;">Reservieren</b-button>

                                <b-button v-if="reCaptchaOK" class="mt-3 text-uppercase" variant="light" @click="handleSubmit" style="float: right;">Reservieren</b-button>
                            </b-form-group>
                        </form>        
                    </b-col>
                </b-row>        
                  
            </b-container>

            <b-container v-if="onSuccess">
                <b-row>
                    <b-col sm="0" md="2" lg="3"></b-col>
                    <b-col sm="12" md="8" lg="6">
                   <h4 class="text-uppercase mb-4">Vielen Dank!</h4>
                   <p>
                    Hervorragend - Ihre Reservierung wurde erfolgreich abgeschlossen, die E-Mail Bestätigung ist auf dem Weg. <br/>
<br/><br/>
                    Bis bald ganz oben! <br/>
                    Das Kahlenberg-Team
                    </p>
                    </b-col>
                    <b-col sm="0" md="2" lg="3"></b-col>
                </b-row>               

            </b-container>
        </b-container>

</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import moment from 'moment';
import FormDate from '@/components/FormDate.vue';

export default {
    components: {        
        VueRecaptcha,   FormDate
    },
    data(){
        return{
            validation:{
                firstname: {MinLetters: 2},
                lastname: {MinLetters: 2},
            },
            booking: {
                firstname: '', firstnameIsValid: true,
                lastname: '', lastnameIsValid: true,
                email: '', email2: '', emailIsValid: true,
                phone: '',
                note: '',
                birthdate: '', birthdateIsValid: true,
                newsletter: false
            },
            showBirthDateInput: true,
            showNewsLetter: true,
            emailDisabled: false,
            siteKey: undefined,
            reCaptchaOK: false,
            reCaptchaToken: undefined,
            onSuccess: false,
            validationError: undefined,           
        }
    },
    methods: {
        dayFormat(value){
           // console.log('formatter', value, typeof(value));
            
            return value.slice(0,2);
        },
        onCaptchaVerified(recaptchaToken){
            //console.log('recaptchaToken: ', recaptchaToken);
            this.reCaptchaOK = true;
            this.reCaptchaToken = recaptchaToken;
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
            this.reCaptchaOK = false;
            this.reCaptchaToken = undefined;
        },
        async loadRecaptchaKeyFromServer() {
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = null;

            await this.$http
                .get(this.$store.getters.getRestServerBaseUrl + "/recaptchaKey", config)
                .then(response => {
                this.siteKey = response.data;
               // console.log('stored recaptchaKey: ', this.$store.getters.getBasket);        
                })
                .catch(err => {
                    console.log("GET recaptchaKey ERROR: ", err);
                });
        },
        handleSubmit() {
            this.validationError = [];
           
            if(this.firstnameState != true){
                this.validationError.push('Vornamen überprüfen');
                this.setIsInvalid("firstnameIsValid");
            }else{
                this.setIsValid("firstnameIsValid"); 
            }

            if(this.lastnameState != true){
                this.validationError.push('Nachnamen überprüfen');    
                this.setIsInvalid("lastnameIsValid");
            }else{
                this.setIsValid("firstnameIsValid"); 
            }

            if(this.booking.email.match(this.$store.getters.getMailFormat) && this.booking.email2.match(this.$store.getters.getMailFormat) && this.booking.email == this.booking.email){
                this.setIsValid("emailIsValid");
            }else{
                // console.log('E-Mail must be given!');  
                this.validationError.push('E-Mail Adressen überprüfen') ;
            
                this.setIsInvalid("emailIsValid");
            }
            
            if( this.validationError != undefined && this.validationError.length > 0){
                //console.log('Validation had errors:', this.validationError);
                
            }else{

                let params = {
                    firstName: this.booking.firstname,
                    lastName: this.booking.lastname,
                    emailAddress: this.booking.email,
                    phone: this.booking.phone,
                    note: this.booking.note,
                    reCaptcha: this.reCaptchaToken, 
                };
                // only save Birthdate for Guests
                if(this.showBirthDateInput && this.booking.birthdate){
                   // console.log('add Birthdate:', this.booking.birthdate);
                    
                    params.birthDate = new Date(this.booking.birthdate).toISOString().slice(0,10);
                }

                if(this.showNewsLetter){
                    if (this.newsletter == true || this.newsletter == 'true') {
                        params.newsletter = true;
                    }else{
                        params.newsletter = false;
                    }

                }

                this.postDirectBooking(params);
            }

        }, 
        async postDirectBooking(params) {      
        
        let config = this.$store.getters.getRestHeaderConfig;
        config.params = undefined; // make sure they are empty           

        //console.log('POST bookReservation:', params, config);

        await this.$http
            .post(this.$store.getters.getRestServerBaseUrl + "/bookReservation", params , config)
            .then(response => {
               // console.log("POST bookReservation response: "  + response.status, response);         
                this.onSuccess = true;
                response.data = '';
            })
            .catch(err => {
                console.log("POST bookReservation ERROR: ", err.response);
                // TODO: Visual ERROR
                this.validationError.push('Buchung nicht erfolgreich, bitte reservieren Sie neu');
            });    
        },
        async loadCustomerDataFromServer() {
           let config = this.$store.getters.getRestHeaderConfig;
           config.params = {                
                //localeId: this.getSelectedLanguage.ident /* Language: de, en */
            };

            await this.$http
                .get(this.$store.getters.getRestServerBaseUrl + "/customer/data", config)
                .then(response => {
                   // console.log("GET customer/data: " + response.status);
                   // console.log(response.data);
                    this.customerData = response.data;

                    // fill in 
                    this.booking.email = response.data.emailAddress;
                    this.booking.email2 = response.data.emailAddress;
                    this.booking.phone = response.data.customerData.phone;

                    this.booking.firstname = response.data.customerData.billingAddress.firstname;
                    this.booking.lastname = response.data.customerData.billingAddress.lastname;

                    if(response.data.customerData.birthDate){
                         this.$refs.BirthDateInput.setDate(new Date(response.data.customerData.birthDate));
                    }

                })
                .catch(err => {
                    console.log("GET customer/data: ", err.response);
                });
        },
        validOrdersFound(){
            //console.log('Load Cached Booking: ', this.$store.getters.getCachedBooking);
            
            if (this.$store.getters.getCachedBooking != undefined){
                //console.log('Booking Info was: ' , this.$store.getters.getCachedBooking);
               
                return true;
            }else{
               // console.log('No Cached Booking info found, redirecting back ...');

                this.$router.go(-1);
                return false;
            }
        },
        setIsValid(item){            
            this.booking[item] = true;
            //console.log('TRUE validated: ', item, this.booking[item]); 
            return item;
        },
        setIsInvalid(item){            
            this.booking[item] = false;
            //console.log('FALSE validated: ', item, this.booking[item]);
            return item;
        }        
    },
    computed: {
        getSelectedLanguage() {
        return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() {
        return this.$store.getters.getLanguageStrings;
        },
        emailState(){
            // this looks like a valid email address 
// this looks like a valid email address
            if(this.booking.email == '' || this.booking.email2 == '' ){
                return;
            }
            if(this.booking.email.match(this.$store.getters.getMailFormat) &&  this.booking.email2.match(this.$store.getters.getMailFormat) && this.booking.email== this.booking.email2){
                this.setIsValid("emailIsValid");
                return true;
            }else{
                this.setIsInvalid("emailIsValid");
                return false;
            }
        },
        firstnameState(){ 
            if (this.booking.firstname.length == 0) {
                return undefined;
            }else if(this.booking.firstname.length > (this.validation.firstname.MinLetters -1) ){               
                this.setIsValid("firstnameIsValid");
                return true;
            }else{
                this.setIsInvalid("firstnameIsValid");
                return false;
            }
        },
        lastnameState(){
            if (this.booking.lastname.length == 0) {
                return undefined;
            }else if(this.booking.lastname.length > (this.validation.lastname.MinLetters -1) ){
                this.setIsValid("lastnameIsValid");
                return true;
            }else{
                this.setIsInvalid("lastnameIsValid");
                return false;
            }
        },
        getDateOfBooking(){
            return moment(this.$store.getters.getCachedBooking.date).format('DD.MM.YYYY');             
        },
        getTimeOfBooking(){
            return moment(this.$store.getters.getCachedBooking.date).format('HH:mm');
        }
    },
    beforeMount() {
        this.loadRecaptchaKeyFromServer();

        if(this.$store.getters.getCustomerLogin.authenticated){
            // hide Date and Newsletter
            this.showBirthDateInput = false;
            this.showNewsLetter = false;
            this.emailDisabled = true;

            this.loadCustomerDataFromServer();
        }else{
           // console.log('Guest Checkout');
        }
    },
    mounted(){
        window.scroll({
            top: 0, 
            left: 0, 
            behavior: 'smooth' 
            }); 
    }
}
</script>
